import React from 'react';
import {  Row, Col, Modal, Button  } from 'react-bootstrap';

const ModalFin = ({show, Quit}) => {

    return (
      <Modal  show={show}  onHide={Quit} centered >
         
      <Modal.Header className="modal-header border-0" style={{justifyContent:'center',alignContent:'center', background: `#3BB9A3`}} closeButton closeVariant="white">
       <Modal.Title id="example-modal-sizes-title-sm">
       <Col style={{color:'white',fontWeight:'bold', fontSize:22, marginInline:20, fontFamily:'Poppins, sans-serif'}}>Merci pour votre demande !</Col>
       </Modal.Title>
     </Modal.Header>
     <Modal.Body style={{background: `white`}}>
     <Row>
     <Col style={{ fontSize:18, marginInline:20,marginTop: 10, fontFamily:'Poppins, sans-serif',color:'#1A2B6E'}}>Nous vous répondons directement par mail sous 48h.</Col>
     </Row>
     
      </Modal.Body>
      <Modal.Footer className="modal-footer border-0" style={{justifyContent: 'center', alignItems: 'center'}}>
      <Button onClick={Quit}  variant="outline-light"  style={{borderWidth:0, background: `#3BB9A3`, borderRadius:30, paddingInline:30, paddingBlock:10, fontSize:17,fontWeight: '600', fontFamily:'Poppins, sans-serif'}}>OK</Button>
     </Modal.Footer>
     
    
   </Modal>
    )
}

export default ModalFin

